import { useSearchParams } from 'react-router-dom'

export default function Banned() {
  const [params] = useSearchParams()
  const reason = params.get('reason') || ''

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas px-4">
      <div className="max-w-md w-full text-center">
        <div className="text-6xl mb-6">🚫</div>
        <h1 className="text-2xl font-bold mb-3 text-fg">Аккаунт заблокирован</h1>
        <p className="text-muted mb-4 leading-relaxed">
          Ваш аккаунт заблокирован администрацией сайта за нарушение правил.
        </p>
        {reason && (
          <div className="mb-6 p-4 rounded-xl bg-surface border border-line text-left">
            <p className="text-xs font-semibold text-muted mb-1">Причина</p>
            <p className="text-sm text-fg">{reason}</p>
          </div>
        )}
        <div className="p-4 rounded-xl bg-surface border border-line text-left">
          <p className="text-xs font-semibold text-muted mb-2">Если вы считаете блокировку ошибочной</p>
          <p className="text-sm text-fg">
            Свяжитесь с администрацией по адресу{' '}
            <span className="text-accent">support@vaumanga.com</span>
          </p>
        </div>
      </div>
    </div>
  )
}
